import React from "react";
import { useTranslation } from 'react-i18next';
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython, faGithub } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "C",
    "C++",
    "C#",   
    "React Native",
    "TypeScript",
    "JavaScript",
    ".NET",
    "Java",
   
   
    
];

const labelsSecond = [
    "REST API",
    "SQL",
    "Firebase",
    "Postman",
    "UML",
    "IoT/Embedded ",
    "WSL",
    "Docker",
    "Kubernetes"
];

const labelsThird = [
    "Git",
    "GitHub",
    "Bitbucket",
    "Scrum",
    "Jira",
    "DevOps-prinsipper"
];

function Expertise() {
    const { t } = useTranslation();
    
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>{t('expertise.title')}</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>{t('expertise.development.title')}</h3>
                    <p>{t('expertise.development.description')}</p>


                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>{t('expertise.system.title')}</h3>
                    <p>{t('expertise.system.description')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faGithub} size="3x"/>
                    <h3>{t('expertise.cooperation.title')}</h3>
                    <p>{t('expertise.cooperation.description')}</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;